// export default YouTubeVideo;

import React, { useState } from 'react';
import LazyImageComponent from './LazyImageComponent';

function YouTubeVideo({ videoId, thumbnail }) {
  const [isVideoVisible, setVideoVisible] = useState(false);

  const handleThumbnailClick = () => {
    setVideoVisible(true);
  };

  const videoUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="video-container">
      {isVideoVisible ? (
        <iframe
          className="youtube-video"
          width="560"
          height="315"
          src={videoUrl}
          frameBorder="0"
          allowFullScreen
          title="YouTube Video"
        ></iframe>
      ) : (
        <LazyImageComponent
          imageUrl={thumbnail}
          alt="Video Thumbnail"
          className="video-thumbnail"
          onClick={handleThumbnailClick}
        />
      )}
    </div>
  );
}

export default YouTubeVideo;


